import { render, staticRenderFns } from "./myFavorite.vue?vue&type=template&id=0ca5b59c&scoped=true"
import script from "./myFavorite.vue?vue&type=script&lang=js"
export * from "./myFavorite.vue?vue&type=script&lang=js"
import style0 from "./myFavorite.vue?vue&type=style&index=0&id=0ca5b59c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca5b59c",
  null
  
)

export default component.exports